module.exports = __webpack_public_path__ + "static/media/no-image.28a81226.png";